/**
xx * axios setup to use mock service
 */

import axios from 'axios';
import { TokenService } from './token.service';
import { urlProvider } from '../url/UrlProviderInstanceManager';

const axiosAuth = axios.create({
    baseURL: urlProvider.getApUrl(),
    withCredentials: true
});

// interceptor for http
axiosAuth.interceptors.request.use(
    (config) => {
        let accessToken = TokenService.getInstance().getAuthAccessToken();
        if (!accessToken) {
            accessToken = TokenService.getInstance().getAccessToken();
        }
        if (config.headers)
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        //config.headers['Authorization'] = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2MzIxZTlhOTViNmFiZTk0MTAzMjViMmQiLCJlbWFpbCI6ImFsdC5kZXZAcmV2b2RpZ2l0YWwuaXQiLCJpbnN0YW5jZUlkIjoiMSIsImlhdCI6MTY2MzU5NDgwOCwiZXhwIjoxNjY0MTk5NjA4fQ.sFFWebBn_b8WP64wXgRo5TjVOs3cmEz9vzhO0JPv8Xw`;

        return config;
    },
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosAuth;